export type Role = 'USER' | 'BUYER_ADMIN' | 'SELLER_ADMIN' | 'SITE_ADMIN';
type Roles = Role[];
type RolesObject = { [key in Role]: Role };

const UserRole: RolesObject = {
  USER: 'USER',
  BUYER_ADMIN: 'BUYER_ADMIN',
  SELLER_ADMIN: 'SELLER_ADMIN',
  SITE_ADMIN: 'SITE_ADMIN',
};

const adminRoles = [UserRole.SITE_ADMIN, UserRole.SELLER_ADMIN, UserRole.BUYER_ADMIN];
const ROLE_HIERARCHY = [UserRole.SITE_ADMIN, UserRole.SELLER_ADMIN, UserRole.BUYER_ADMIN, UserRole.USER];

const verifyRole = (targetRole: Role, roles: Roles) => {
  return roles.includes(targetRole);
};

const verifyRoleAtLeast = (targetRole: Role, role: Role) => {
  const roles = ROLE_HIERARCHY.slice(0, ROLE_HIERARCHY.indexOf(targetRole) + 1);
  return verifyRole(role, roles);
};

const verifyRoleAdmin = (role: Role) => {
  return adminRoles.includes(role);
};

const verifyRoleAtLeastSellerAdmin = (role: Role) => {
  return verifyRoleAtLeast(UserRole.SELLER_ADMIN, role);
};

const getRemainingHierarchy = (role: Role) => {
  const roles = ROLE_HIERARCHY.slice(ROLE_HIERARCHY.indexOf(role));
  return roles;
};

export { verifyRoleAdmin, verifyRoleAtLeastSellerAdmin, getRemainingHierarchy, ROLE_HIERARCHY, verifyRoleAtLeast };
